/* =====================================================================
   pareti-offerte.js — fiche produit Rivestimento Pareti (spec §4.6 à 4.8)
   Chargé par sections/main-product.liquid et sections/featured-product.liquid
   (defer), après constants.js, pubsub.js et global.js de Dawn (chargés dans
   <head>, defer).

   1. <pr-buy> (snippets/buy-buttons.liquid) : un contrôleur par section produit.
      - cartes d'offre par quantité (snippets/pr-offerte.liquid) : carte choisie,
        totaux, prix à l'unité, « Risparmi X € », ligne livraison ; calculs en
        centimes à partir du PRIX RÉEL de la variante (aucun prix barré) ;
        remise = Math.floor(sous-total × % / 100) : arrondie au centime
        inférieur, le total affiché n'est jamais plus bas que celui du panier
        (même calcul dans pr-offerte.liquid ; 3 paniers tests, spec §9.5) ;
      - articles « aggiungi all'ordine » (snippets/pr-upsell.liquid) ;
      - total affiché dans le bouton ([data-pr-atc-total]) ;
      - ajout au panier : 1 article sans upsell → formulaire Dawn inchangé ;
        sinon interception du submit et POST /cart/add.js avec la liste
        des lignes (lignes identiques regroupées), puis tiroir panier Dawn.
      - suit la variante principale (PUB_SUB_EVENTS.variantChange de Dawn).
   2. <pr-sticky-atc> (snippets/sticky-atc.liquid) : barre d'achat collante,
      total de l'offre courante, écrit --pr-satc-h sur <body> (bouton WhatsApp).
   3. <pr-consegna> (snippets/pr-consegna.liquid) : recalcule dans le navigateur
      la date maximale de livraison (aujourd'hui + N jours ouvrés lun-ven) pour
      ne jamais afficher une date figée par le cache de page.

   v2 (14/10/2026) : panier « notification » de Dawn géré aussi (réglage
   cart_type de l'utilisateur) : la notification montre le 1er article ajouté,
   la pastille du panier compte toutes les lignes. Sans tiroir ni
   notification : redirection vers /cart.

   Aucun cœur Dawn modifié (global.js, product-form.js, cart-drawer.js).
   La remise réelle est appliquée par les remises automatiques Shopify
   (mêmes paliers) : ce script n'applique aucune remise lui-même.
   ===================================================================== */
(function () {
  'use strict';

  var TOTALS = (window.prTotali = window.prTotali || {});

  function hasPubSub() {
    return typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function decodeEntities(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* Format monétaire Shopify (shop.money_format), en centimes */
  function formatMoney(cents, format) {
    var value = Math.round(Number(cents) || 0);
    var fmt = format || '{{amount_with_comma_separator}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(re);
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var out;
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount':
        out = delim(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        out = delim(value, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = delim(value, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = delim(value, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = delim(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        out = delim(value, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        out = delim(value, 2, ' ', '.');
        break;
      default:
        out = delim(value, 2, '.', ',');
    }
    return m ? fmt.replace(re, out) : out;
  }

  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function optionPrice(select) {
    var o = selectedOption(select);
    return o ? parseInt(o.getAttribute('data-price'), 10) || 0 : 0;
  }

  function updateThumb(select) {
    var row = select.closest('.pr-off__pick-row');
    var o = selectedOption(select);
    if (!row || !o) return;
    var src = o.getAttribute('data-img');
    var img = row.querySelector('[data-thumb] img');
    if (src && img) img.src = src;
  }

  /* ------------------------------------------------------------------
     1. Contrôleur par section produit
     ------------------------------------------------------------------ */
  function Controller(cfg) {
    this.cfg = cfg;
    this.id = cfg.getAttribute('data-section');
    this.format = decodeEntities(cfg.getAttribute('data-money-format'));
    this.price = parseInt(cfg.getAttribute('data-price'), 10) || 0;
    this.available = cfg.getAttribute('data-available') !== 'false';
    this.root = cfg.closest('product-info') || cfg.closest('.shopify-section') || document.body;
    this.productForm = cfg.parentElement ? cfg.parentElement.querySelector('product-form') : null;

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onRequest = this.onRequest.bind(this);

    this.root.addEventListener('change', this.onChange);
    this.root.addEventListener('click', this.onClick);
    /* phase de capture sur <product-form> : passe AVANT l'écouteur submit du <form> (Dawn) */
    if (this.productForm) this.productForm.addEventListener('submit', this.onSubmit, true);
    document.addEventListener('pr:richiedi-totale', this.onRequest);

    var self = this;
    if (hasPubSub()) {
      this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        self.onVariant(evt);
      });
    }
    this.refresh();
  }

  Controller.prototype.destroy = function () {
    this.root.removeEventListener('change', this.onChange);
    this.root.removeEventListener('click', this.onClick);
    if (this.productForm) this.productForm.removeEventListener('submit', this.onSubmit, true);
    document.removeEventListener('pr:richiedi-totale', this.onRequest);
    if (this.unsub) this.unsub();
  };

  Controller.prototype.fmt = function (cents) {
    return formatMoney(cents, this.format);
  };

  Controller.prototype.offer = function () {
    return this.root.querySelector('[data-pr-offerte][data-section="' + this.id + '"]') || this.root.querySelector('[data-pr-offerte]');
  };

  Controller.prototype.onRequest = function (e) {
    if (e.detail && e.detail.section === this.id) this.refresh();
  };

  Controller.prototype.onVariant = function (evt) {
    var d = evt && evt.data;
    if (!d || String(d.sectionId) !== String(this.id)) return;
    var v = d.variant;
    if (!v) {
      this.available = false;
      this.refresh();
      return;
    }
    this.price = Number(v.price) || 0;
    this.available = !!v.available;
    var id = String(v.id);
    /* articles 2..n jamais modifiés par le client : ils suivent la variante principale */
    this.root.querySelectorAll('[data-unit-select]').forEach(function (sel) {
      if (sel.getAttribute('data-touched')) return;
      var opt = sel.querySelector('option[value="' + id + '"]');
      if (opt && !opt.disabled) {
        sel.value = id;
        updateThumb(sel);
      }
    });
    this.refresh();
  };

  Controller.prototype.onChange = function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('.pr-off__radio')) {
      this.refresh();
    } else if (t.matches('[data-unit-select]')) {
      t.setAttribute('data-touched', '1');
      updateThumb(t);
      /* même article dans les autres cartes : même choix (le client ne perd pas sa sélection) */
      var n = t.getAttribute('data-unit');
      var val = t.value;
      this.root.querySelectorAll('[data-unit-select][data-unit="' + n + '"]').forEach(function (s) {
        if (s === t) return;
        var o = s.querySelector('option[value="' + val + '"]');
        if (o && !o.disabled) {
          s.value = val;
          s.setAttribute('data-touched', '1');
          updateThumb(s);
        }
      });
      this.refresh();
    } else if (t.matches('[data-pr-upsell-select]')) {
      var row = t.closest('.pr-up__row');
      var cb = row ? row.querySelector('[data-pr-upsell]') : null;
      var price = optionPrice(t);
      if (cb) {
        cb.value = t.value;
        cb.setAttribute('data-price', String(price));
      }
      var priceEl = row ? row.querySelector('[data-pr-upsell-price]') : null;
      if (priceEl) priceEl.textContent = this.fmt(price);
      this.refresh();
    } else if (t.matches('[data-pr-upsell]')) {
      this.refresh();
    }
  };

  /* clic n'importe où dans une carte (hors contrôles) = choisir la carte */
  Controller.prototype.onClick = function (e) {
    var card = e.target.closest ? e.target.closest('.pr-off__card') : null;
    if (!card || e.target.closest('select, option, label, input, a, button')) return;
    var radio = card.querySelector('.pr-off__radio');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  /* Recalcule les cartes et renvoie { qty, total } de la carte choisie */
  Controller.prototype.renderOffer = function (offer) {
    var self = this;
    var soglia = parseInt(offer.getAttribute('data-soglia'), 10) || 0;
    var strUnit = offer.getAttribute('data-str-unit') || '';
    var strSave = offer.getAttribute('data-str-save') || '';
    var chosen = null;
    offer.querySelectorAll('.pr-off__card').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var pct = parseFloat(card.getAttribute('data-pct')) || 0;
      var sels = card.querySelectorAll('[data-unit-select]');
      var sub = self.price;
      if (sels.length) {
        sels.forEach(function (s) {
          sub += optionPrice(s);
        });
      } else {
        sub = self.price * qty;
      }
      /* centime inférieur (voir en-tête) ; + 1e-9 : protège des erreurs de virgule flottante */
      var discount = Math.floor((sub * pct) / 100 + 1e-9);
      /* palier « produit » (data-round="unit") : Shopify arrondit la remise pièce par pièce */
      if (card.getAttribute('data-round') === 'unit') {
        discount = Math.floor((self.price * pct) / 100 + 1e-9);
        if (sels.length) {
          sels.forEach(function (s) {
            discount += Math.floor((optionPrice(s) * pct) / 100 + 1e-9);
          });
        } else {
          discount = discount * qty;
        }
      }
      var total = sub - discount;
      var unit = Math.round(total / qty);

      var el = card.querySelector('[data-total]');
      if (el) el.textContent = self.fmt(total);
      el = card.querySelector('[data-unit]');
      if (el && strUnit) el.textContent = strUnit.replace('[prezzo]', self.fmt(unit));
      el = card.querySelector('[data-save]');
      if (el && strSave) el.textContent = strSave.replace('[importo]', self.fmt(discount));
      el = card.querySelector('[data-ship-free]');
      if (el) el.hidden = total < soglia;
      el = card.querySelector('[data-ship-paid]');
      if (el) el.hidden = total >= soglia;

      var radio = card.querySelector('.pr-off__radio');
      var on = !!(radio && radio.checked);
      card.classList.toggle('is-selected', on);
      card.classList.toggle('is-unavailable', !self.available);
      if (on) chosen = { qty: qty, total: total };
    });
    return chosen || { qty: 1, total: this.price };
  };

  Controller.prototype.refresh = function () {
    var offer = this.offer();
    var res = offer ? this.renderOffer(offer) : { qty: 1, total: this.price };
    var extra = 0;
    var extraCount = 0;
    this.root.querySelectorAll('[data-pr-upsell]').forEach(function (cb) {
      if (cb.checked) {
        extra += parseInt(cb.getAttribute('data-price'), 10) || 0;
        extraCount += 1;
      }
    });
    var grand = res.total + extra;
    var formatted = this.fmt(grand);
    this.root.querySelectorAll('[data-pr-atc-total]').forEach(function (el) {
      el.textContent = formatted;
    });
    var detail = {
      section: this.id,
      qty: res.qty,
      extra: extraCount,
      total: grand,
      formatted: formatted,
      available: this.available,
    };
    TOTALS[this.id] = detail;
    document.dispatchEvent(new CustomEvent('pr:totale', { detail: detail }));
  };

  /* Lignes à ajouter au panier : [{ id, quantity }] */
  Controller.prototype.collectItems = function () {
    var input = this.productForm ? this.productForm.querySelector('[name="id"]') : null;
    var mainId = input ? input.value : '';
    if (!mainId) return null;
    var ids = [mainId];
    var offer = this.offer();
    if (offer) {
      var radio = offer.querySelector('.pr-off__radio:checked');
      var card = radio ? radio.closest('.pr-off__card') : null;
      if (card) {
        var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        var sels = card.querySelectorAll('[data-unit-select]');
        if (sels.length) {
          sels.forEach(function (s) {
            ids.push(s.value || mainId);
          });
        } else {
          for (var i = 1; i < qty; i++) ids.push(mainId);
        }
      }
    }
    this.root.querySelectorAll('[data-pr-upsell]:checked').forEach(function (cb) {
      if (cb.value) ids.push(cb.value);
    });
    var counts = {};
    var order = [];
    ids.forEach(function (id) {
      if (!counts[id]) {
        counts[id] = 0;
        order.push(id);
      }
      counts[id] += 1;
    });
    return order.map(function (id) {
      return { id: Number(id), quantity: counts[id] };
    });
  };

  Controller.prototype.onSubmit = function (e) {
    var items = this.collectItems();
    if (!items) return;
    var count = items.reduce(function (a, it) {
      return a + it.quantity;
    }, 0);
    /* 1 seul article : le formulaire Dawn fait le travail */
    if (items.length === 1 && count === 1) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var pf = this.productForm;
    var btn = pf.querySelector('[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    var spinner = pf.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var isNotification = !!cart && cart.tagName.toLowerCase() === 'cart-notification';
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && res.status) {
          if (typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage(res.description || res.message);
          if (hasPubSub()) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'pr-offerte',
              productVariantId: items[0].id,
              errors: res.errors || res.description,
              message: res.message,
            });
          }
          return;
        }
        /* sans tiroir (panier en « notification » ou page) : aller au panier */
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (hasPubSub()) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pr-offerte', productVariantId: items[0].id, cartData: res });
        if (isNotification) {
          /* la notification Dawn affiche une ligne : celle de l'article principal (1re ligne ajoutée) */
          var first = res.items && res.items[0];
          if (!first || !res.sections) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          res.key = first.key;
          res.id = first.id;
          try {
            cart.renderContents(res);
          } catch (err) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          return;
        }
        cart.renderContents(res);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (err) {
        console.error(err);
        if (typeof pf.handleErrorMessage === 'function') {
          pf.handleErrorMessage((window.cartStrings && window.cartStrings.error) || '');
        }
      })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  };

  if (!customElements.get('pr-buy')) {
    customElements.define(
      'pr-buy',
      class PrBuy extends HTMLElement {
        connectedCallback() {
          if (!this.controller) this.controller = new Controller(this);
        }
        disconnectedCallback() {
          if (this.controller) this.controller.destroy();
          this.controller = null;
        }
      }
    );
  }

  /* ------------------------------------------------------------------
     2. Barre d'achat collante
     ------------------------------------------------------------------ */
  if (!customElements.get('pr-sticky-atc')) {
    customElements.define(
      'pr-sticky-atc',
      class PrStickyAtc extends HTMLElement {
        connectedCallback() {
          /* hors de la colonne produit : un parent transformé (animations Dawn) casserait position:fixed */
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return;
          }
          this.setup();
        }

        disconnectedCallback() {
          this.teardown();
        }

        setup() {
          if (this.ready) return;
          var self = this;
          this.section = this.getAttribute('data-section');
          /* une seule barre par section (rechargement de section dans l'éditeur, échange de produit) */
          document.querySelectorAll('pr-sticky-atc[data-section="' + this.section + '"]').forEach(function (el) {
            if (el !== self) el.remove();
          });
          this.main =
            document.getElementById('ProductSubmitButton-' + this.section) ||
            document.querySelector('product-form form[action*="/cart/add"] [name="add"]');
          if (!this.main) return;
          this.ready = true;
          this.btn = this.querySelector('[data-pr-satc-btn]');
          this.totalEl = this.querySelector('[data-pr-satc-total]');
          this.btnLabels = this.querySelectorAll('[data-pr-satc-label]');
          this.isOn = null;
          this.hidden = false;
          this.footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');

          /* Défilement (rAF) plutôt qu'IntersectionObserver : un saut direct de « sous l'écran »
             à « au-dessus de l'écran » (lancer rapide, ancre) ne déclenche aucun changement d'intersection. */
          this.raf = null;
          this.onScroll = function () {
            if (self.raf) return;
            self.raf = window.requestAnimationFrame(function () {
              self.raf = null;
              self.compute();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.compute();

          this.onTotal = function (e) {
            if (e.detail && e.detail.section === self.section) self.applyTotal(e.detail);
          };
          document.addEventListener('pr:totale', this.onTotal);
          if (TOTALS[this.section]) this.applyTotal(TOTALS[this.section]);
          else document.dispatchEvent(new CustomEvent('pr:richiedi-totale', { detail: { section: this.section } }));

          this.onBtn = function () {
            if (self.main.disabled || self.main.getAttribute('aria-disabled') === 'true') return;
            self.main.click();
          };
          this.btn.addEventListener('click', this.onBtn);

          this.syncDisabled();
          this.mo = new MutationObserver(function () {
            self.syncDisabled();
          });
          this.mo.observe(this.main, { attributes: true, attributeFilter: ['disabled'] });
        }

        teardown() {
          if (this.onScroll) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
          if (this.raf) window.cancelAnimationFrame(this.raf);
          if (this.mo) this.mo.disconnect();
          if (this.onTotal) document.removeEventListener('pr:totale', this.onTotal);
          if (this.btn && this.onBtn) this.btn.removeEventListener('click', this.onBtn);
          if (this.ready) document.body.style.setProperty('--pr-satc-h', '0px');
          this.ready = false;
        }

        applyTotal(d) {
          if (this.totalEl && d.formatted) this.totalEl.textContent = d.formatted;
        }

        syncDisabled() {
          var off = !!this.main.disabled;
          this.btn.disabled = off;
          this.classList.toggle('is-sold-out', off);
          var soldOut = window.variantStrings ? window.variantStrings.soldOut : '';
          this.btnLabels.forEach(function (el) {
            el.textContent = off && soldOut ? soldOut : el.getAttribute('data-label');
          });
        }

        compute() {
          if (!this.main || !this.main.isConnected) return;
          var above = this.main.getBoundingClientRect().bottom < 0;
          var footerIn = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
          var on = above && !footerIn;
          if (on !== this.isOn) this.setVisible(on);
        }

        setVisible(on) {
          this.isOn = on;
          this.classList.toggle('is-on', on);
          if (on) {
            this.removeAttribute('inert');
            this.removeAttribute('aria-hidden');
          } else {
            this.setAttribute('inert', '');
            this.setAttribute('aria-hidden', 'true');
          }
          document.body.style.setProperty('--pr-satc-h', on ? this.offsetHeight + 'px' : '0px');
        }
      }
    );
  }

  /* ------------------------------------------------------------------
     3. Date maximale de livraison (règle salam : délai maximal visible)
        « giorni lavorativi » = lundi à vendredi SAUF jours fériés nationaux
        italiens (sinon la date annoncée tombe avant le vrai terme de
        N jours ouvrés, par ex. autour de Noël). Même liste dans
        snippets/pr-consegna.liquid.
     ------------------------------------------------------------------ */
  var FESTIVI_FISSI = ['1-1', '1-6', '4-25', '5-1', '6-2', '8-15', '11-1', '12-8', '12-25', '12-26'];
  var pasquetta = {};

  /* Lundi de Pâques (Pasquetta) : algorithme grégorien anonyme (Meeus/Jones/Butcher) */
  function pasquettaKey(y) {
    if (pasquetta[y]) return pasquetta[y];
    var a = y % 19;
    var b = Math.floor(y / 100);
    var c = y % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    var monday = new Date(y, month - 1, day + 1);
    pasquetta[y] = monday.getMonth() + 1 + '-' + monday.getDate();
    return pasquetta[y];
  }

  function isFestivo(dt) {
    var key = dt.getMonth() + 1 + '-' + dt.getDate();
    return FESTIVI_FISSI.indexOf(key) !== -1 || key === pasquettaKey(dt.getFullYear());
  }

  if (!customElements.get('pr-consegna')) {
    customElements.define(
      'pr-consegna',
      class PrConsegna extends HTMLElement {
        connectedCallback() {
          var max = parseInt(this.getAttribute('data-max'), 10);
          var out = this.querySelector('[data-pr-consegna-data]');
          if (!out || !(max > 0)) return;
          var giorni = (this.getAttribute('data-giorni') || '').split(',');
          var mesi = (this.getAttribute('data-mesi') || '').split(',');
          if (giorni.length !== 7 || mesi.length !== 12) return;
          var d = new Date();
          var n = 0;
          var guard = 0;
          while (n < max && guard < 400) {
            d.setDate(d.getDate() + 1);
            var wd = d.getDay();
            if (wd !== 0 && wd !== 6 && !isFestivo(d)) n += 1;
            guard += 1;
          }
          out.textContent = giorni[d.getDay()].trim() + ' ' + d.getDate() + ' ' + mesi[d.getMonth()].trim();
        }
      }
    );
  }
})();
